import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import Environment from './plugins/Environment'
import VueStorage from './plugins/Storage'
import Moment from 'moment'
import store from '@/store'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(VueResource)
Vue.use(VueStorage)
Vue.use(Toast, {
    transition: 'Vue-Toastification__fade',
    maxToasts: 20,
    newestOnTop: true,
    position: 'bottom-right',
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: false,
    icon: true,
    rtl: false
})

Vue.http.interceptors.push((request, next) => {
    if (Vue.storage.get('sessionId', null) !== null) {
        request.headers.set('Authorization', 'Bearer ' + Vue.storage.get('sessionId'))
    }
    next((response) => {
        if (response.status === 401) {
            Vue.storage.remove('sessionId')
            if (router.currentRoute.fullPath !== '/' && !router.currentRoute.meta?.auth) {
                router.push({ name: 'login', query: { disconnected: true } })
            }
        }
    })
})

Environment.getAPIUrl().then((url) => {
    Vue.http.options.root = url
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
})

Vue.filter('datetime', (date, format) => {
    if (!format) {
        format = 'YYYY-MM-DD hh:mm:ss'
    }
    return Moment.utc(date).format(format)
})

Vue.filter('isoformat', (date) => {
    return Moment.utc(date).toISOString()
})

Vue.filter('relative', (date, relative) => {
    return Moment.utc(date).fromNow()
})

Vue.filter('pluralize', (quantity, plural) => {
    if (!plural) {
        plural = 's'
    }

    return quantity === 1 ? '' : plural
})

Vue.filter('capitalize', (value) => {
    const parts = value.toLowerCase().split(' ')
    parts.forEach((x, index) => {
        parts[index] = x.charAt(0).toUpperCase() + x.slice(1)
    })
    return parts.join(' ')
})

Vue.filter('floating', (value, suffix) => {
    if (typeof value !== 'number') {
        value = parseFloat(value)
    }

    if (isNaN(value)) {
        return null
    }

    if (!suffix) {
        suffix = '$ USD'
    }

    return value.toFixed(2).replace('.00', '') + suffix
})

Vue.filter('number', val => parseFloat(val).toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).replace('.00', ''))
